import NodeAuth from "node-auth-api";
import moment from "moment";

const urls = {
  nodeAuth: {
    local: "http://localhost:3009",
    staging: "http://mdmicroservices.com/auth",
    production: "https://mdmicroservices.com/auth"
  }
};

export function configureFor(env = "local") {
  let allowedEnv = ["local", "staging", "production"];
  if (!allowedEnv.includes(env)) env = "local";

  NodeAuth.setUrl(urls.nodeAuth[env]);

  loadData();
}

function loadData() {
  NodeAuth.Company.login("gobus", "gobus_1315!");
}

export const defaultDelay = 1500;

export function getModalStyle() {
  const top = 50; //+ rand();
  const left = 50; // + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  };
}


// data formatters
export function formatDate(date) {
  return moment(date).format("YYYY/MM/DD");
}

export function formatPrice(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatDateWithTime(date) {
  return moment(date).format("YYYY/MM/DD hh:mm A");
}

export function getCardType(id) {
  let types = {
    1: "Delivery",
    2: "Fawry/Aman",
    3: "Credit Card"
    //3: "Aman"
  };
  return types[Number(id)] || "Unknown";
}

export function getCardStatus(status) {
  let statuses = {
    3: "Pending",
    4: "Approved"
  };
  return statuses[Number(status)] || "Unknown";
}

export const styles = theme => ({
  paper: {
    position: "absolute",
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: "none"
  }
});
